"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.metric = void 0;
const zod_1 = require("zod");
const _1 = require(".");
var metric;
(function (metric_1) {
    metric_1.metric = zod_1.z.object({
        metricId: zod_1.z.string(),
        name: zod_1.z.string(),
        definition: zod_1.z.object({
            modelId: zod_1.z.string(),
            operations: _1.queryPipeline.operation.array().optional(),
            aggregation: zod_1.z.object({
                type: _1.common.aggregationType,
                key: zod_1.z.string().optional(),
            }),
        }),
    });
})(metric || (exports.metric = metric = {}));
//# sourceMappingURL=metric.js.map